<template>
  <v-app>

    <v-app-bar
      app
      flat
      :color="tenantColor"
      dark
      class="d-block d-sm-none"
      style="background-color: rgb(18,18,18)"
      height="64"
    >
      <!--v-spacer></v-spacer-->
      <!--v-btn text @click="goBack" style="margin-right: 100px">
        <v-icon>mdi-arrow-left-circle</v-icon-->
        <!--span class="mr-2">Späť</span-->
      <!--/v-btn-->
    </v-app-bar>

    <v-app-bar
      app
      flat
      :color="tenantColor"
      dark
      class="d-none d-sm-block"
      height="64"
    >

      <div class="d-flex align-center">
        <v-img
          alt="Telekom Logo"
          class="shrink mr-2"
          contain
          :src="require('@/assets/logos/app/telekom-1.png')"
          transition="scale-transition"
          v-if="tenant == 'GO' || tenant == 'TMCZ_GO'"
        />
        <!-- DIGI tenant intentionally shows no header logo (blue bar kept for differentiation) -->
        <v-img
          alt="Telekom Logo"
          class="shrink mr-2"
          contain
          :src="require('@/assets/logos/app/telekom-1.png')"
          transition="scale-transition"
          v-else-if="tenant != 'DIGI'"
        />
      </div>

      <!--
      <nav>
        <router-link to="/">Simulator</router-link> |
        <router-link to="/login">Login</router-link> |
        <router-link to="/consents">Consents</router-link> |
        <router-link to="/allowpartner">Allow</router-link>
      </nav>
      -->

      <!--v-spacer></v-spacer-->

      <!--v-btn text @click="goBack" style="margin-right: 130px">
        <v-icon>mdi-arrow-left-circle</v-icon-->
        <!--span class="mr-2">Späť</span-->
      <!--/v-btn-->

    </v-app-bar>

    <v-main class="pt-5">
      <router-view @updateLanguage="updateLanguage" @updateTenant="updateTenant" :languagestrings="languagestrings" :toperror="error" />
    </v-main>
  </v-app>
</template>

<style scoped>

@font-face {
    font-family: 'TeleGroteskNext'; /*a name to be used later*/
    src: url('@/assets/TeleGroteskNext/Webfonts/TeleGroteskNext-Regular.woff')
}

#app {
  font-family: TeleGroteskNext, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
}

/*
#app a {
  color: #00A0DE !important;
}

.v-application nav a {
  color: #2c3e50 !important;
}
*/

nav {
  padding: 30px;
  color: white;
  font-size: 14px;
}

nav a {
  font-weight: bold;
  color: white;
}

nav a.router-link-exact-active {
  color: white;
}

nav a:link, a:visited {
  color: white;
  text-decoration: none;
}

nav a:hover, a:active {
  color: white;
  text-decoration: none;
}
</style>

<script>
import { api } from "./main";
import VueCookies from 'vue-cookies'

export default {
  name: 'App',

  data: () => ({
    tenant: 'GO',
    language: 'SK',
    languagestrings: {},
    error: '',
    baseUrl: {},
    stringsUrl: {}
  }),

  computed: {
    tenantColor() {
      return this.tenant == 'DIGI' ? 'rgb(0,160,222)' : '#EA0A8E'; // '#0095DA'
    }
  },

  methods: {
    goBack() {
        this.$router.go(-1)
    },
    updateTenant(tenant) {
      //console.log('updateTenant', tenant)
      this.tenant = tenant;
      VueCookies.set('tenant', tenant);
    },
    updateLanguage(language) {
      this.language = language;
      VueCookies.set('language', language);
      this.loadStrings();
    },

    async loadConfig() {
        // HTTP REQUEST
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        var res = await api.requestData('./json/config.json', options);

        // REQUEST RESULTS ACTIONS
        if(Object.prototype.hasOwnProperty.call(res, 'status')) {
            if(res.status == 'ok') {
                if(Object.prototype.hasOwnProperty.call(res.responseBody, "server")) {
                  api.setConfig(res.responseBody);
                  this.baseUrl = api.getBaseUrl; //res.responseBody.server;
                }
                return res.responseBody;
            }
            else {
                if(res.responseStatus == 'ECONNRESET') {
                    this.error = 'Pripojenie na server zlyhalo.';
                }
                else {
                    this.error = res.responseBody.error_description;
                }
            }
        }
        else {
            this.error = 'Pripojenie na server zlyhalo.';
        }
    },

    async loadStrings() {
        // VALIDATE INPUT
        if(!this.language) {
            this.language = 'SK';
        }
        // HTTP REQUEST
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        var res = await api.requestData(api.getStringsUrl()[this.tenant] + '?language=' + this.language, options); // http://ottlab.magio.tv:1027/home/getStrings
        
        // REQUEST RESULTS ACTIONS
        if(Object.prototype.hasOwnProperty.call(res, 'status')) {
            if(res.status == 'ok') {
                if(res.responseBody.data.length > 0) {
                    this.languagestrings = {};
                    res.responseBody.data.forEach((str) => {
                        this.languagestrings[str.id] = str.value;
                    });
                    return this.strings;
                }
            }
            else {
                if(res.responseStatus == 'ECONNRESET') {
                    this.error = 'Pripojenie na server zlyhalo.';
                }
                else {
                    this.error = res.responseBody.error_description;
                }
            }
        }
        else {
            this.error = 'Pripojenie na server zlyhalo.';
        }
    },
    print(input_prop) {
      return api.print(this.languagestrings, input_prop);
    }
  },

  created: async function(){
    if(Object.prototype.hasOwnProperty.call(this.$route.query, 'tenant')) {
      this.tenant = this.$route.query.tenant
    }
    else {
      this.tenant = VueCookies.get('tenant');
    }
    this.language = VueCookies.get('language');
    if(this.tenant && this.tenant.length > 0) {
        if(!this.language || (this.tenant == 'TMCZ_GO' && this.language == 'SK') || (this.tenant != 'TMCZ_GO' && this.language == 'CZ')) {
            if(this.tenant == 'TMCZ_GO') {
                this.language = 'CZ';
            }
            else {
                this.language = 'SK';
            }
        }
    }
    else {
        this.language = 'EN';
    }

    /*var config = */await this.loadConfig();
    //console.log('config', config);
    /*var strings = */await this.loadStrings();
    //console.log('strings', strings);
    document.title = this.print('SSO_WEB.WEBSITE_PAGE_TITLE');
  },

  mounted: function() {
    /*
    if(this.tenant == 'GO' || this.tenant == 'TMCZ_GO') {
      document.title = 'Telekom: Prihlásenie do Voyo';
    }
    else if (this.tenant == 'DIGI') {
      document.title = 'DIGI: Prihlásenie do Voyo';
    }
    else {
      document.title = 'Telekom: Prihlásenie do Voyo';
    }
    */
  },
  
  watch: {
  },

};
</script>
